import type { NavigationGuardWithThis } from "vue-router";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { FORBIDDEN_MESSAGE } from "@/utils/forbidden";
import { hasAnyPermission } from "@/utils/permissions";

export function requireAnyPermission(
  slugs: readonly string[]
): NavigationGuardWithThis<undefined> {
  return async (_to, _from, next) => {
    if (!store.getters.isUserAuthenticated) {
      next();
      return;
    }

    let permissions = store.getters.getPermissions || [];

    if (!hasAnyPermission(permissions, slugs)) {
      try {
        await store.dispatch(Actions.VERIFY_AUTH);
      } catch {
        // VERIFY_AUTH already handles an invalid session.
      }

      permissions = store.getters.getPermissions || [];

      if (!hasAnyPermission(permissions, slugs)) {
        Swal.fire({
          title: "Acceso denegado",
          text: FORBIDDEN_MESSAGE,
          icon: "error",
          confirmButtonText: "Aceptar",
        });

        const homePage = store.getters.getHomePage;
        next(homePage ? { name: homePage } : { name: "dashboard" });
        return;
      }
    }

    next();
  };
}
